function tryDocAutoFocus() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const focusable = document.documentElement.querySelector('[autofocus]');

      if (focusable) {
        focusable.focus();

        return;
      }

      const element = document.documentElement.querySelector('.field_with_errors');

      if (element) {
        element.scrollIntoView();
      }
    });
  });
}

export function setupTurboAutoFocuser() {
  document.documentElement.addEventListener('turbo:render', ev => {
    tryDocAutoFocus();
  }, false);

  document.documentElement.addEventListener('turbo:frame-render', ev => {
    tryDocAutoFocus();
  }, false);

  document.documentElement.addEventListener('turbo:before-stream-render', ev => {
    tryDocAutoFocus();
  }, false);
}
